//get address from google using {lat: lat, lng:lng}
export async function fetchAddress(latLng) {
  if (!latLng) return null

  const geocoder = new google.maps.Geocoder()

  return new Promise((resolve, reject) => {
    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === 'OK' && results.length > 0) {
        resolve(results[0])
      } else {
        reject(new Error('Failed to fetch address'))
      }
    })
  })
}
